export enum DisplayMode {
  Creation,
  Edition
}
